const { id } = require("../std/index")


//
// Lightbox Trigger Widget
//
// Really it's only job is to be something which reports clicks to the
// Lightbox controller. Pretty simple.
//

module.exports = class LightboxWidget {
  constructor($host, config) {
    this.dom = { main: $host };

    this.callbacks = { click: id };

    this.dom.main.on('click', () => this.callbacks.click(config.lightbox));
  }

  onClick(λ) {
    this.callbacks.click = λ;
  }
};
